/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullAccordionPanelFragment = gql`
  ${AccordionFragment}
  ${BaseAccordionPanelFragment}
  ${ImageFragment}
  ${VideoFragment}

  fragment FullAccordionPanelFragment on AccordionPanel {
    ...BaseAccordionPanelFragment

    accordionsCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
      }
    }
    accordionsCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
      }
    }
    media {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
